import HeaderNonhomePage from "../components/Layout/HeaderNonhomePage";
import ResultsContentLayout from "../components/Results/ResultsContentLayout";
import "./Results.css";

const Results = () => {
  return(
    <div id="results-wrapper">
      <HeaderNonhomePage page_title="Competition Results" />
      <ResultsContentLayout />
    </div>
  );
};

export default Results;